import React from 'react'
// ##
import OrdersReportView from '../../modules/OrdersReportView/components/OrdersReport'

export default function OrdersReportPage() {
  return <OrdersReportView />
}
